// eslint-disable-next-line import/no-anonymous-default-export
export default {
  'Forms Roles': 'صلاحيات الاستمارات',
  'FormsRoles LIST': 'قائمة بيانات الاستمارات',
  'Add Form Role': 'اضافة صلاحية استمارة',
};
